let padInt = function(int, padSize, padChar) {
	padSize = padSize || 2;
	padChar = '0';
	return (padChar.repeat(padSize)+int.toString()).substr(-padSize);
}

export default {
	escapeHtml: function(unsafe) {
		return (unsafe||'')
			.replace(/&/g, "&amp;")
			.replace(/</g, "&lt;")
			.replace(/>/g, "&gt;")
			.replace(/"/g, "&quot;")
			.replace(/'/g, "&#39;");
	},

	buildQueryString: function(params) {
		return new URLSearchParams(params).toString();
	},

	decodeEntities: function(encodedString) {
		var translate_re = /&(nbsp|amp|quot|lt|gt);/g;
		var translate = {
			"nbsp":" ",
			"amp" : "&",
			"quot": "\"",
			"lt"  : "<",
			"gt"  : ">"
		};
		return encodedString.replace(translate_re, function(match, entity) {
			return translate[entity];
		}).replace(/&#(\d+);/gi, function(match, numStr) {
			var num = parseInt(numStr, 10);
			return String.fromCharCode(num);
		});
	},

	padInt: padInt,

	secondsToTime: function(sec) {
		if(typeof sec === 'undefined' || sec === null)
			return '--:--';

		sec = sec || 0;
		sec = Math.floor(sec);

		var s = sec % 60;
		var m = Math.floor(sec / 60) % 60;
		var h = Math.floor(sec / 60 / 60);

		var str =
			'' +
			(h ? `${h}:` : '') +
			(h ? padInt(m, 2, '0') : (m ? `${m}` : '0')) +
			':' + (padInt(s||0, 2, '0'));

		return str;
	},

	generateRandomString(length) {
		var result = '';

		var randomChars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
		for(var i = 0; i < length; i++) {
			result += randomChars.charAt(Math.floor(Math.random() * randomChars.length));
		}

		return result;
	},

	trim(str) {
		return str.replace(/^[ \t\r\n]+/, '').replace(/[ \t\r\n]+$/, '');
	},

	normalizeSpaces(str) {
		return str.replace(/[ \t\r\n]+/g, ' ');
	},

	// https://stackoverflow.com/questions/36734201/how-to-convert-numbers-to-million-in-javascript
	moneyString(value, digits) {
		if(value === null)
			return null;

		if(!value) return '-';

		digits = digits || 1;

		var n = Math.abs(Number(value));
		var ret =
			n >= 1.0e+9
			?
				(n / 1.0e+9).toFixed(digits) + "B"
			:
				n >= 1.0e+6 // Six Zeroes for Millions
				?
					(n / 1.0e+6).toFixed(digits) + "M"
				:
					n >= 1.0e+3 // Three Zeroes for Thousands
					?
						(n / 1.0e+3).toFixed(digits) + "K"
					:
						n;

		return ret;
	},

	bytesString(n, precision) {
		if(n === 0) return '0';
		const units = ['','K','M','G','T','P','E'];
		const i = Math.floor(Math.log(n) / Math.log(1024));
		const value = n / Math.pow(1024, i);
		if(typeof precision === 'undefined') precision = 1;
		return `${parseFloat(value.toFixed(precision))}${units[i]}`;
	},

	dateToSqlString(date) {
		return (typeof date === 'undefined') ? date : `${date.getFullYear()}-${padInt(date.getMonth() + 1, 2, '0')}-${padInt(date.getDate(), 2, '0')} ${padInt(date.getHour(), 2, '0')} ${padInt(date.getMinute(), 2, '0')} ${padInt(date.getSecond(), 2, '0')}`;
	},

	sqlStringToDate(str) {
		if(!str)
			return str;

		var t = str.split(/[- :T.]/);
		return new Date(Date.UTC(parseInt(t[0]), parseInt(t[1])-1, parseInt(t[2]), parseInt(t[3]), parseInt(t[4]), parseInt(t[5])));
	},

	randomItem(items) {
		if(Array.isArray(items)) {
			items = items.filter(a => a !== null && typeof a !== 'undefined');
			return items[Math.floor(Math.random() * items.length)];
		}

		return items;
	},
	setTimeoutPromise(ms, signal) {
		return new Promise((resolve, reject) => {
			const tid = setTimeout(resolve, ms);
			signal?.addEventListener('abort', event => {
				clearTimeout(tid);
				reject(event);
			});
		});
	},
	setImmediatePromise() {
		return new Promise(resolve => setImmediate(resolve));
	},
	fetchWithTimeout(url, options, timeoutMs) {
		const controller = new AbortController();
		const id = timeoutMs && setTimeout(() => controller.abort(), timeoutMs);
		return fetch(url, { ...options, signal: controller.signal }).finally(() => {
			if(id) clearTimeout(id);
		});
	},

	// Return a promise that resolves when all media elements inside a given element have been loaded
	awaitMediaLoadedRecursive(elem, timeout) {
		timeout = timeout || 1000;
		return Promise.race([
			this.setTimeoutPromise(timeout),
			Promise.all(Array.from(elem.querySelectorAll('img,video,audio')||[]).map(elem => new Promise(resolve => {
				if(elem.complete) return resolve();
				const loaded = () => {
					elem.removeEventListener('load', loaded);
					resolve();
				};
				elem.addEventListener('load', loaded);
				const errored = () => {
					elem.removeEventListener('error', errored);
					resolve(); // we don't really care if there's an error
				};
				elem.addEventListener('error', errored);
			}))),
		]);
	},

	relativeDate(date) {
		const diff = Math.round((new Date() - new Date(date)) / 1000);

		const minute = 60;
		const hour = minute * 60;
		const day = hour * 24;
		const week = day * 7;
		const month = day * 30;
		const year = month * 12;

		if (diff < 30) {
			return "just now";
		} else if (diff < minute) {
			return diff + " seconds ago";
		} else if (diff < 2 * minute) {
			return "a minute ago";
		} else if (diff < hour) {
			return Math.floor(diff / minute) + " minutes ago";
		} else if (Math.floor(diff / hour) == 1) {
			return "1 hour ago";
		} else if (diff < day) {
			return Math.floor(diff / hour) + " hours ago";
		} else if (diff < day * 2) {
			return "yesterday";
		} else if (diff < week) {
			return week + " days ago";
		} else if (diff < month) {
			return Math.floor(diff / week) + " weeks ago";
		} else if (diff < year) {
			return Math.floor(diff / month) + " months ago";
		} else {
			const years = Math.floor(diff / year);
			return `${years} year${years == 1 ? '' : 's'} ago`;
		}
	},

	getLocationQueryParam(paramName) {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});

		return params[paramName];
	},

	escapeRegExp(str) {
		return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	},

	generateSpreadShadowFilter(spread, blur, color) {
		spread = spread || 0;
		blur = blur || 0;
		if(!spread && !blur) return 'none';
		const ret = [];
		const nPoints = 4;
		const delta = (Math.PI * 2) / nPoints;
		for(let n = 0, a = 0; n < nPoints; n++, a += delta) {
			const x = Math.round(spread * Math.cos(a));
			const y = Math.round(spread * Math.sin(a));
			ret.push(`drop-shadow(${x}px ${y}px ${blur}px ${color})`);
		}
		return ret.join(' ');
	},

	getIndefiniteArticle(word) {
		const vowels = ['a', 'e', 'i', 'o', 'u'];
		const lowercaseWord = word.toLowerCase();

		// Known initialisms (spoken as individual letters)
		const initialisms = ['FBI', 'CIA', 'NSA', 'MRE', 'MRI', 'UN', 'EU', 'UFO'];

		if (initialisms.includes(word)) {
			const pronouncedWithAn = ['A', 'E', 'F', 'H', 'I', 'L', 'M', 'N', 'O', 'R', 'S', 'X'];
			return pronouncedWithAn.includes(word[0]) ? 'an' : 'a';
		}

		// Special cases for regular words
		if (/^hour/.test(lowercaseWord)) return 'an';
		if (/^honest/.test(lowercaseWord)) return 'an';
		if (/^heir/.test(lowercaseWord)) return 'an';
		if (/^u[bcfhjkqrstnlg]/.test(lowercaseWord)) return 'a'; // university, user

		return vowels.includes(lowercaseWord[0]) ? 'an' : 'a';
	},

	generateValueString(value, currency, options) {
		const digits = currency > 0 && currency < 0.01 ? 6 : 2;
		try {
			return `${new Intl.NumberFormat(navigator.language||'en-US', { style: 'currency', currency, minimumFractionDigits: 0, maximumFractionDigits: digits, ...(options||{}) }).format(value)}`;
		} catch(e) {
			return `${Number(Number(value).toFixed(digits))} ${currency}`;
		}
	},

	generateGiftString(message, giftType) {
		const isFancy = giftType?.value && giftType?.currency;
		const multiplier = message.multiplier||1;
		const string = isFancy ? giftType?.string||`sent ${this.getIndefiniteArticle(message.giftName||giftType?.name||message.giftType)} {type}` : '';
		const stringMulti = isFancy ? giftType?.string_multi||'sent {multiplier}×{type}' : '';
		let displayString = `${(multiplier == 1 ? string : stringMulti).replace('{type}', message.giftName||giftType?.name||message.giftType).replace('{multiplier}', multiplier).replace('#', multiplier)}`;
		let ttsString = isFancy ? displayString.replaceAll('_', ' ') : '';

		if(message.currency) {
			let valueString = this.generateValueString(message.value * multiplier, message.currency);
			if(!isFancy) ttsString += ` sent ${valueString}`;

			if(message.convertedValue && message.convertedCurrency && message.convertedCurrency.toLowerCase() != message.currency.toLowerCase()) {
				valueString += ' / ';
				valueString += this.generateValueString(message.convertedValue * multiplier, message.convertedCurrency);
			}
			displayString += displayString ? ` (${valueString})` : valueString;
		}

		if(message.product) {
			const productString = `bought a ${message.product}`;
			if(displayString) displayString += ' and ';
			if(ttsString) ttsString += ' and ';
			displayString += productString;
			ttsString += productString;
		}

		ttsString += ` on ${message.serviceName}`;

		return { displayString, isFancy, ttsString };
	},

	spansToHtml(spans) {
		return (spans||[]).filter(s => s).map(span => {
			if(typeof span == 'string') return this.escapeHtml(span);
			if(span.type == 'br') return '<br />';
			if(span.text) {
				let html = this.escapeHtml(span.text);
				const tagTypes = {
					bold: 'B',
					italic: 'I',
					underline: 'U',
					strikethrough: 'S',
					code: 'CODE',
				};
				for(let attr in tagTypes) {
					if(!span[attr]) continue;
					html = `<${tagTypes[attr]}>${html}</${tagTypes[attr]}>`;
				}
				if(span.color || span.bgColor)
					html = `<span style="${span.color ? `color:${this.escapeHtml(span.color)};` : ''}${span.bgColor ? `background-color:${this.escapeHtml(span.bgColor)};` : ''}">${html}</span>`;
				return html;
			}
			if(span?.type == 'image' || span?.type == 'emote' || span?.type == 'sticker') {
				let html = `
					<${span.video ? 'video' : 'img'}
						class="${span.type}${span.class ? ` ${span.class}` : ''}"
						alt="${this.escapeHtml(span.alt||'')}"
						referrerpolicy="no-referrer"
						crossorigin="anonymous"
						${span.title ? ` title="${this.escapeHtml(span.title)}"` : ''}
						${span.video ? `><source src="${this.escapeHtml(span.src)}" /></video` : `src="${this.escapeHtml(span.src)}"`}
					>
				`;
				return html;
			}
			return null;
		}).filter(s => s).join('');
	},

	spansToDom(spans) {
		return (spans||[]).filter(s => s).map(span => {
			if(typeof span == 'string') return document.createTextNode(span);
			if(span.type == 'br') return document.createElement('br');
			if(span.text) {
				let node = document.createTextNode(span.text);
				const tagTypes = {
					bold: 'B',
					italic: 'I',
					underline: 'U',
					strikethrough: 'S',
					code: 'CODE',
				};
				for(let attr in tagTypes) {
					if(!span[attr]) continue;
					const e = document.createElement(tagTypes[attr]);
					e.appendChild(node);
					node = e;
				}
				if(span.color)
					node.style.color = span.color;
				if(span.bgColor)
					node.style.backgroundColor = span.bgColor;
				return node;
			}
			if(span?.type == 'image' || span?.type == 'emote' || span?.type == 'sticker') {
				const node = document.createElement(span.video ? 'video' : 'img');
				node.classList.add(span.type);
				node.referrerPolicy = 'no-referrer';
				node.crossOrigin = 'anonymous';
				node.src = span.src;
				if(span.title) node.title = span.title;
				node.alt = span.alt || '';
				if(span.class) node.classList.add(span.class);
				return node;
			}
		}).filter(s => !!s);
	},

	prepareMessage(msg, fields, data) {
		const ret = {
			message: msg,
			serviceId: msg?.serviceId,
			token: msg?.id,
			dbId: msg.dbId,
			id: `${msg.serviceId}-${msg.id||this.generateRandomString(20)}`,
			channelToken: msg.target?.channelToken,
			chatToken: msg.target?.chatToken,
			chatterToken: msg.sender?.token||msg.sender?.id||msg.sender?.username||msg.sender?.displayName||'-',
		};

		if(fields.serviceName) ret.serviceName = msg.serviceName;
		if(fields.serviceIcon || fields.serviceIconUrl) {
			if(msg.serviceIconUrl || (String(msg?.serviceId) in data.serviceIcons)) {
				ret.serviceIconUrl = msg.serviceIconUrl||data.serviceIcons[msg.serviceId];
				if(fields.serviceIcon && ret.serviceIconUrl) {
					ret.serviceIcon = document.createElement('IMG');
					ret.serviceIcon.src = ret.serviceIconUrl;
					ret.serviceIcon.alt = msg.serviceName;
					ret.serviceIcon.title = msg.serviceName;
					ret.serviceIcon.classList.add('service');
				}
			}
		}

		if(fields.avatarIcon || fields.avatarUrl) {
			ret.avatarUrl = msg.sender?.avatar;
			if(fields.avatarIcon && ret.avatarUrl) {
				const avatarElem = document.createElement('IMG');
				avatarElem.src = msg.sender?.avatar;
				avatarElem.classList.add('avatar');
				ret.avatarIcon = avatarElem;
			}
		}

		ret.displayName = msg.sender?.displayName || msg.sender?.username || msg.sender?.token;
		if(fields.displayNameElem && ret.displayName) {
			const nameElem = document.createElement('B');
			nameElem.classList.add('name');
			nameElem.innerText = ret.displayName;
			ret.displayNameElem = nameElem;
		}

		const isGift = msg.giftType && msg.value > 0;
		if(fields.isGift) ret.isGift = isGift;

		const isSubscription = msg.type=='subscription' || msg.type=='reSub' || msg.type=='subGift' || msg.type=='subExtend';
		if(fields.isSubscription) ret.isSubscription = isSubscription;
		const isProduct = !!msg.product;
		const otherAlerts = [ 'follow', 'host', 'subGiftReceive', 'subStreak', 'like', 'tower', 'goal', 'alert' ];
		const isAlert = isGift || isSubscription || isProduct || otherAlerts.includes(msg.type);
		if(fields.isAlert) ret.isAlert = isAlert;

		const isHighlighted = msg.serviceId && data?.user?.highlighted_message?.serviceId == msg.serviceId && data?.user?.highlighted_message?.token == msg.id;
		if(fields.isHighlighted) ret.isHighlighted = isHighlighted;

		if((fields.giftAmount || fields.speakProlog || fields.sounds) && isGift) ret.giftAmount = this.generateValueString(msg.value * (msg.multiplier||1), msg.currency);

		if(isGift) {
			const { displayString, ttsString } = this.generateGiftString(msg, data?.giftTypes?.[msg.serviceId]?.[msg.giftType]);
			ret.giftString = displayString;
			ret.speakProlog = !msg.ttsUrl && !msg.externalTtsUrl && `${ret.displayName} ${ttsString}`;
		}

		if(fields.giftElem && ret.giftString) {
			ret.giftElem = document.createElement('span');
			if(isGift)
				ret.giftElem.classList.add('gift');
			if(msg.product)
				ret.giftElem.classList.add('merch');

			ret.giftElem.appendChild(document.createTextNode(ret.giftString));
		}

		if(fields.song) ret.song = msg.song;
		if(msg.type != 'tower') {
			if(fields.media) ret.media = msg.media;
			if(fields.mediaString || fields.mediaElem) {
				if(msg.media) {
					ret.mediaString = `${msg.mediaTitle||msg.media}${msg.mediaDuration?` (${this.secondsToTime(msg.mediaDuration)})`:''}`;
					ret.mediaElem = document.createElement('div');
					ret.mediaElem.classList.add('media');
					ret.mediaElem.appendChild(document.createTextNode(ret.mediaString));
				}
			}
		}
		const thresholdValue = msg.convertedValue || 1;
		if(fields.giftColorThreshold && isGift)
			ret.giftColorThreshold = this.getGiftThreshold(thresholdValue, data.giftColorThresholds||[]);

		if(fields.eventString) {
			switch(msg.type) {
				case 'timeout': ret.eventString = `was timed out${msg.seconds > 0 ? ` for ${this.timeDuration(msg.seconds)}` : ''}`; break;
				case 'subscription': ret.eventString = `subscribed ${msg.numMonths ? `for ${this.monthDuration(msg.numMonths)}` : 'monthly'} `; break;
				case 'resubscribe': ret.eventString = `resubscribed for ${this.monthDuration(data.length)} ${data.months ? ' and is now on a ' + data.months + ' month sub streak' : ''}`; break;
				case 'subGift': ret.eventString = `gifted ${this.formatAmountLabel(msg.count||1, 'subscription')}${msg.receiver?` to ${msg.receiver}`:''}`; break;
				case 'subGiftReceive': ret.eventString = `received a subscription${msg.gifter ? ` from ${msg.gifter}` : ''}`; break;
				case 'subStreak': ret.eventString = `is celebrating a ${msg.length} month subscription streak`; break;
				case 'ban': ret.eventString = `was banned${msg.bannedBy?` by ${msg.bannedBy.displayName||msg.bannedBy.displayName}`:''}${msg.reason?`: ${msg.reason}`:''}`; break;
				case 'unban': ret.eventString = `was unbanned${msg.unbannedBy?` by ${msg.unbannedBy.displayName}`:''}${msg.reason?`: ${msg.reason}`:''}`; break;
				case 'moderator': ret.eventString = `${msg.add?`was made moderator`:`is no longer a moderator`}`; break;
				case 'host': ret.eventString = `hosted${msg.numViewers?` with ${msg.numViewers} viewers`:''}`; break;
				case 'live': ret.eventString = `is streaming ${msg.title||''} ${msg.url?` at ${msg.url}`:''}`; break;
				case 'offline': ret.eventString = `is offline ${msg.url?` at ${msg.url}`:''}`; break;
				case 'delete': ret.eventString = `deleted ${msg.ids?` ${msg.ids.join(', ')}`:''}`; break;
				case 'follow': ret.eventString = `followed`; break;
				case 'unfollow': ret.eventString = `unfollowed`; break;
				case 'join': ret.eventString = `joined`; break;
				case 'leave': ret.eventString = `left`; break;
				case 'like': ret.eventString = `liked the stream`; break;
				case 'subExtend': ret.eventString = `extended his subscription${msg.length?` for ${this.monthDuration(msg.length)}`:''}`; break;
				case 'tower': ret.eventString = `Tower built: ${msg.message||msg.string}`; break;
				case 'goal': ret.eventString = `completed the dono goal`; break;
			}
		}

		if(fields.shortEvent) {
			switch(msg.type) {
				case 'subscription': ret.shortEvent = `Sub ${msg.numMonths ? ` ${this.monthDuration(msg.numMonths)}` : ''}`; break;
				case 'resubscribe': ret.shortEvent = `Resub ${this.monthDuration(data.length)}`; break;
				case 'subGift': ret.shortEvent = `Gift ${this.formatAmountLabel(msg.count||1, 'sub')}`; break;
				case 'subGiftReceive': ret.shortEvent = `Get sub`; break;
				case 'subStreak': ret.shortEvent = `${msg.length}mo streak`; break;
				case 'host': ret.shortEvent = `Host ${msg.numViewers?` (${msg.numViewers})`:''}`; break;
				case 'follow': ret.shortEvent = `Follow`; break;
				case 'subExtend': ret.shortEvent = `Extend sub ${msg.length?` ${this.monthDuration(msg.length)}`:''}`; break;
				case 'chat': if(isProduct) ret.shortEvent = 'Merch'; break;
				case 'tower': ret.shortEvent = msg.string||'Tower'; break;
				case 'goal': ret.shortEvent = 'Goal'; break;
			}
		}

		if(fields.spansDom || fields.spansHtml || fields.speak || fields.sounds) {
			const doReplacements = (str, internal) => (data.textReplacements||[]).filter(r => !r.internal||internal).reduce((accum, val) => accum.replaceAll(val.expression, val.replacement), str||'');
			const doSpansReplacements = (spans, internal) => (spans||[]).map(s => {
				if(typeof s == 'string') return doReplacements(s, internal);
				if('text' in s) s = { ...s, text: doReplacements(s.text, internal) };
				if('title' in s) s = { ...s, title: doReplacements(s.title, internal) };
				if('alt' in s) s = { ...s, alt: doReplacements(s.alt, internal) };
				return s;
			});
			if(fields.spansDom)
				ret.spansDom = this.spansToDom(doSpansReplacements(msg.spans));
			if(fields.spansHtml)
				ret.spansHtml = msg.message?.string || this.spansToHtml(doSpansReplacements(msg.spans));
			if((fields.speak || fields.sounds) && !data.ignoreSpeak && !msg.sender?.isSelf && !msg.mml && msg.sender?.settings?.tts_status !== 'muted')
				ret.speak = (doSpansReplacements(msg.spans, true)).map(s => this.trim(this.normalizeSpaces(typeof s === 'string' ? s : (s.text || s.title || '')))).filter(a => !!a).join(' ');
		}

		if(fields.classList) {
			ret.classList = [];
			ret.classList.push('message');
			ret.classList.push(msg.type);
			if(msg.sender?.isSelf) ret.classList.push('self');
			if(msg.sender?.isOwner) ret.classList.push('owner');
			if(msg.sender?.isModerator) ret.classList.push('moderator');
			if(msg.sender?.isAnonymous) ret.classList.push('anonymous');
			if(isHighlighted) ret.classList.push('highlighted');
			if(msg.loading) ret.classList.push('loading');
			if(isSubscription) ret.classList.push('subscription');
			if(isGift) ret.classList.push('gift');
			if(isProduct) ret.classList.push('product');
			if(ret.giftColorThreshold) ret.classList.push(`gift-${ret.giftColorThreshold.value}`);
		}
		if(fields.canReply) ret.canReply = !!data?.channels?.find(c => c.service_id == msg?.serviceId && c.token == msg?.target?.channelToken);

		if(fields.group && isGift) ret.group = msg.giftType && data.giftTypes?.[msg.serviceId]?.[msg.giftType]?.group || false;
		if(fields.groupId && isGift) ret.groupId = [ msg.serviceId, ret.chatterToken, msg.giftType ].map(a => a||'').join('-');

		if(fields.images) {
			if(isGift) {
				if(msg.giftIcon) ret.images = [ msg.giftIcon ];
				else if(msg.icon) ret.images = [ msg.icon ];
				else {
					const giftMedia = data.giftTypes?.[msg.serviceId]?.[msg.giftType]?.media || [];
					const thresholdAny = data.giftMediaThresholds?.toReversed?.()?.find?.(t => t.amount - .001 <= thresholdValue && t.files?.length > 0);
					const thresholdFiles = thresholdAny?.files || [];
					let images = giftMedia.filter(m => m.mime?.[0] == 'image');
					if(!images?.length) images = data.giftTypes?.[msg.serviceId]?.[msg.giftType]?.image && [ data.giftTypes[msg.serviceId][msg.giftType].image ];
					if(!images?.length) images = thresholdFiles.filter(f => f.mime[0] == 'image');
					if(!images?.length) images = (data.eventTypes?.gift?.media || []).filter(m => m.mime?.[0] == 'image');
					if(!images?.length) images = (data.eventTypes?.alert?.media || []).filter(m => m.mime?.[0] == 'image');
					ret.images = images?.length > 0 && Array.from({ length: msg.multiplier||1 }, () => this.randomItem(images));
				}
			} else if(msg.type == 'tower') {
				let images = msg.media?.filter(f => f?.mime?.[0] == 'image');
				if(!images?.length) images = (data.eventTypes?.tower?.media || []).filter(m => m.mime?.[0] == 'image');
				if(!images?.length) images = (data.eventTypes?.alert?.media || []).filter(m => m.mime?.[0] == 'image');
				ret.images = [ this.randomItem(images) ];
			} else {
				if(msg.icon) ret.images = [ msg.icon ];
				else {
					const eventMedia = data.eventTypes?.[msg.type]?.media || [];
					const alertMedia = isAlert ? (data.eventTypes?.alert?.media || []) : [];
					const allMedia = eventMedia.length > 0 ? eventMedia : alertMedia;
					const images = allMedia.filter(m => m.mime?.[0] == 'image');
					ret.images = images.length ? [ this.randomItem(images) ] : [];
				}
			}
		}

		if(fields.sounds) {
			const alertSounds = [];
			const sounds = [];

			const maybePushRandomItem = (arr, items, comment) => items?.length > 0 && arr.push({ type: 'url', comment, url: this.randomItem(items).url });

			if(isGift) {
				maybePushRandomItem(alertSounds, (data.giftTypes?.[msg.serviceId]?.[msg.giftType]?.media || []).filter(m => m.mime?.[0] == 'audio'), 'gift type');
				const threshold = data.giftMediaThresholds?.toReversed?.()?.find?.(t => t.amount - .001 <= thresholdValue && t.files?.filter?.(f => f.mime[0] == 'audio')?.length > 0);
				maybePushRandomItem(alertSounds, threshold?.files?.filter(f => f.mime[0] == 'audio'), 'gift threshold');
				maybePushRandomItem(alertSounds, (data.eventTypes?.gift?.media || []).filter(m => m.mime?.[0] == 'audio'), 'gift');
			} else if(msg.type == 'tower') {
				maybePushRandomItem(alertSounds, msg.media?.filter(f => f?.mime?.[0] == 'audio'), 'tower media');
				maybePushRandomItem(alertSounds, (data.eventTypes?.tower?.media || []).filter(m => m.mime?.[0] == 'audio'), 'tower');
			} else if(msg.type != 'chat') {
				if(isAlert) {
					maybePushRandomItem(alertSounds, (data.eventTypes?.[msg.type]?.media || []).filter(m => m.mime?.[0] == 'audio'), `alert ${msg.type}`);
				} else {
					maybePushRandomItem(sounds, (data.eventTypes?.[msg.type]?.media || []).filter(m => m.mime?.[0] == 'audio'), `event ${msg.type}`);
				}
			} else if(msg.mml) {
				maybePushRandomItem(sounds, [{ type: 'mml', mml: msg.mml, instrument: msg.sender?.settings?.instrument }], 'mml');
			} else {
				maybePushRandomItem(sounds, (data.eventTypes?.chat?.media || []).filter(m => m.mime?.[0] == 'audio'), 'chat');
			}

			if(isAlert)
				maybePushRandomItem(sounds, (data.eventTypes?.alert?.media || []).filter(m => m.mime?.[0] == 'audio'), 'alert');
			maybePushRandomItem(sounds, (data.eventTypes?.default?.media || []).filter(m => m.mime?.[0] == 'audio'), 'default');

			ret.sounds = [];
			const items = [];
			if(alertSounds?.length > 0) items.push(alertSounds);
			if(ret.speakProlog) {
				items.push({
					type: 'tts',
					isProlog: true,
					speak: ret.speakProlog,
					provider: msg.ttsVoice&&msg.ttsProvider||msg.sender?.settings?.voice_id&&msg.sender?.settings?.voice_provider,
					voice: msg.ttsProvider&&msg.ttsVoice||msg.sender?.settings?.voice_provider&&msg.sender?.settings?.voice_id,
					rate: msg.ttsRate||msg.sender?.settings?.rate,
					pitch: msg.ttsPitch||msg.sender?.settings?.pitch,
					style: msg.ttsStyle||msg.sender?.settings?.style,
					role: msg.ttsRole||msg.sender?.settings?.role,
				});
			}
			if(ret.speak) {
				if(msg.ttsUrl || msg.externalTtsUrl) {
					items.push({ type: 'tts', url: msg.ttsUrl || msg.externalTtsUrl, proxy: msg.externalTtsUrl });
				} else {
					items.push({
						type: 'tts',
						speak: ret.speak,
						provider: msg.ttsVoice&&msg.ttsProvider||msg.sender?.settings?.voice_id&&msg.sender?.settings?.voice_provider,
						voice: msg.ttsProvider&&msg.ttsVoice||msg.sender?.settings?.voice_provider&&msg.sender?.settings?.voice_id,
						rate: msg.ttsRate||msg.sender?.settings?.rate,
						pitch: msg.ttsPitch||msg.sender?.settings?.pitch,
						style: msg.ttsStyle||msg.sender?.settings?.style,
						role: msg.ttsRole||msg.sender?.settings?.role,
					});
				}
			}

			if(msg.song)
				items.push({ type: 'song', song: msg.song });
			if(items.length > 0)
				ret.sounds.push(items.length == 1 ? items[0] : { type: 'any', items });
			ret.sounds.push(sounds);
		}

		if(fields.consoleLog) {
			let con = [ '' ];
			if(msg.serviceName) {
				con[0] += `%c${msg.serviceName}%c `;
				con.push('color: #888');
				con.push('color: inherit');
			}
			if(msg.sender?.avatarUrl) {
				con[0] += '%c   ';
				con.push(`background-image: url('${msg.sender?.avatarUrl}'); background-size: auto 1.2em; background-repeat: no-repeat`);
			}
			if(msg.sender?.displayName) {
				con[0] += `%c${msg.sender?.displayName||msg.sender?.username||'-'}%c`;
				con.push('font-weight: bold');
				con.push('font-weight: normal');
			}
			if(ret.giftString) con.push(ret.giftString);
			if(ret.eventString) con.push(ret.eventString);
			if(ret.spansHtml) {
				con.push(': ');
				con.push(ret.spansHtml);
			}
			ret.consoleLog = con;
		}

		return ret;
	},

	getGiftThreshold(value, thresholds) {
		return thresholds.toReversed().find(t => t.value - .011 <= value) || thresholds?.[0];
	},

	createChatLogMessage(msg, data, options) {
		const prepared = this.prepareMessage(msg, {
			classList: true,
			serviceIcon: true,
			serviceName: true,
			avatarIcon: true,
			displayNameElem: true,
			spansDom: true,
			giftElem: true,
			giftColorThreshold: true,
			mediaElem: true,
			eventString: true,
			canReply: true,
			isAlert: true,
		}, data);

		const div = document.createElement('div');
		div.dataset.id = prepared.dbId;
		if(prepared.id) div.id = prepared.id;
		div.classList.add('message');
		for(let c of prepared.classList)
			div.classList.add(c);

		div.onclick = () => {
			if(window.getSelection().focusOffset != window.getSelection().anchorOffset) return;
			options?.onclick?.(prepared);
		};

		const menuBtn = document.createElement('div');
		menuBtn.classList.add('menubtn');
		menuBtn.onclick = ev => {
			ev.stopPropagation();
			ev.preventDefault();
			options?.onmenuclick?.(prepared);
		};
		div.appendChild(menuBtn);

		if(prepared.serviceIcon) div.appendChild(prepared.serviceIcon);
		if(prepared.avatarIcon) div.appendChild(prepared.avatarIcon);
		if(prepared.displayNameElem) div.appendChild(prepared.displayNameElem);
		if(prepared.giftElem) div.appendChild(prepared.giftElem);
		if(prepared.eventString) div.appendChild(document.createTextNode(prepared.eventString));
		if((prepared.eventString || prepared.giftElem) && prepared.spansDom) div.appendChild(document.createTextNode(' '));
		if(prepared.spansDom) prepared.spansDom.forEach(elem => div.appendChild(elem));
		if(prepared.mediaElem) div.appendChild(prepared.mediaElem);

		return div;
	},

	timeAgo(then) {
		const now = new Date();
		const diffInSeconds = Math.floor((now - then) / 1000);

		const rtf = new Intl.RelativeTimeFormat(navigator.language || 'en', { numeric: 'auto' });

		const intervals = {
			year: 31536000,
			month: 2592000,
			week: 604800,
			day: 86400,
			hour: 3600,
			minute: 60,
			second: 1,
		};

		for(let unit in intervals) {
			const interval = Math.floor(diffInSeconds / intervals[unit]);
			if(interval >= 1) {
				return rtf.format(-interval, unit);
			}
		}

		return 'just now';
	},

	// time duration for ban times
	// 300 -> "X was banned for 5 minutes"
	timeDuration(seconds) {
		const locale = navigator.language || 'en';

		const divisions = [
			{ unit: 'year', seconds: 31536000 },
			{ unit: 'month', seconds: 2592000 },
			{ unit: 'week', seconds: 604800 },
			{ unit: 'day', seconds: 86400 },
			{ unit: 'hour', seconds: 3600 },
			{ unit: 'minute', seconds: 60 },
			{ unit: 'second', seconds: 1 },
		];

		for (const { unit, seconds: unitSeconds } of divisions) {
			if (Math.abs(seconds) >= unitSeconds || unit === 'second') {
				const value = Math.floor(seconds / unitSeconds);

				const nf = new Intl.NumberFormat(locale, {
					style: 'unit',
					unit,
					unitDisplay: 'long'
				});

				return nf.format(value);
			}
		}
	},
	monthDuration(months) {
		return new Intl.NumberFormat(navigator.language || 'en', {
			style: 'unit',
			unit: 'month',
			unitDisplay: 'long' // 'short' or 'narrow' also available
		}).format(months);
	},

	extractEmojis(text) {
		if(typeof Intl !== "undefined" && Intl.Segmenter) {
			const segmenter = new Intl.Segmenter("en", { granularity: "grapheme" });
			return [...segmenter.segment(text)]
				.map(seg => seg.segment)
				.filter(s =>
					/\p{Extended_Pictographic}/u.test(s) ||           // normal emojis
					/^[\u{1F1E6}-\u{1F1FF}]{2}$/u.test(s)             // country flags (2 regional indicators)
				);
		} else {
			// Fallback: regex that catches both pictographs & flag sequences
			return text.match(
				/\p{Extended_Pictographic}(?:\u200D\p{Extended_Pictographic})*|[\u{1F1E6}-\u{1F1FF}]{2}/gu
			) || [];
		}
	},

	getContrastingTextColor(bgColor, darkColor = '#241e32', lightColor = '#eee9f0') {
		const getLuminance = (hex) => {
			const rgb = hex.replace('#', '').match(/.{2}/g).map(c => {
				const val = parseInt(c, 16) / 255;
				return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
			});
			return 0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2];
		};

		const getContrastRatio = (lum1, lum2) => {
			const L1 = Math.max(lum1, lum2);
			const L2 = Math.min(lum1, lum2);
			return (L1 + 0.05) / (L2 + 0.05);
		};

		const bgLum = getLuminance(bgColor);
		const darkLum = getLuminance(darkColor);
		const lightLum = getLuminance(lightColor);

		const contrastWithDark = getContrastRatio(bgLum, darkLum);
		const contrastWithLight = getContrastRatio(bgLum, lightLum);

		return contrastWithDark > contrastWithLight ? darkColor : lightColor;
	},

	formatAmountLabel(amount, noun, options = {}) {
		const {
			locale = navigator.language || 'en',
			pluralSuffix = 's',      // Optional override for irregular plurals
			article = true           // Whether to prepend "a"/"an" for singular
		} = options;

		const isSingular = amount === 1;

		if(isSingular) {
			if(article) {
				const startsWithVowel = /^[aeiou]/i.test(noun);
				const articleText = startsWithVowel ? 'an' : 'a';
				return `${articleText} ${noun}`;
			} else {
				return `1 ${noun}`;
			}
		} else {
			const pluralRules = new Intl.PluralRules(locale);
			const category = pluralRules.select(amount);

			// For now we only handle regular "s" suffix, but allow override
			const pluralNoun =
				category === 'one'
					? noun
					: pluralSuffix === 's'
						? noun + 's'
						: pluralSuffix;

			return `${amount} ${pluralNoun}`;
		}
	},

	// Preload an image and resolve with the HTMLImageElement.
	// urlOrImg: a URL string, or a pre-created Image element (src will be set by this function).
	// options.signal: AbortSignal — rejects with AbortError if fired
	// options.crossOrigin: value for img.crossOrigin (e.g. 'anonymous')
	preloadImage(urlOrImg, { signal, crossOrigin } = {}) {
		return new Promise((resolve, reject) => {
			if(signal?.aborted) return reject(new DOMException('Aborted', 'AbortError'));

			const img = typeof urlOrImg === 'string' ? new Image() : urlOrImg;

			if(crossOrigin) img.crossOrigin = crossOrigin;
		img.referrerPolicy = 'no-referrer';

			const cleanup = () => {
				img.removeEventListener('load', onLoad);
				img.removeEventListener('error', onError);
				signal?.removeEventListener('abort', onAbort);
			};

			const onLoad  = () => { cleanup(); resolve(img); };
			const onError = () => { cleanup(); reject(new Error('Image failed to load')); };
			const onAbort = () => {
				cleanup();
				if(img.src) img.src = '';
				reject(new DOMException('Aborted', 'AbortError'));
			};

			img.addEventListener('load', onLoad);
			img.addEventListener('error', onError);
			signal?.addEventListener('abort', onAbort);

			if(img.complete && img.naturalWidth !== 0) {
				cleanup();
				return resolve(img);
			}

			if(typeof urlOrImg === 'string') img.src = urlOrImg;
		});
	},

	// Polyfill for AbortSignal.any() — not available in older Chromium/OBS versions.
	signalAny(signals) {
		if(AbortSignal.any) return AbortSignal.any(signals);
		const ac = new AbortController();
		const abort = () => ac.abort();
		for(const signal of signals) {
			if(signal.aborted) { ac.abort(); return ac.signal; }
			signal.addEventListener('abort', abort, { once: true });
		}
		return ac.signal;
	},
};
